<div class="ie-pos-loader" role="status" aria-live="polite" aria-label="Cargando contenido">
  <div class="printer-wrapper">
    <div class="loader-glow"></div>

    <div class="ticket-area">
      <div class="ticket">
        <div class="ticket-content">
          <div class="ticket-mark"></div>
          <div class="t-line"></div>
          <div class="t-line"></div>
          <div class="t-line"></div>
          <div class="t-line short"></div>
        </div>
        <div class="ticket-edge"></div>
      </div>
    </div>

    <div class="printer-hardware">
      <div class="printer-top">
        <div class="paper-slot"></div>
      </div>
      <div class="printer-front">
        <div class="brand-dot"></div>
        <div class="front-line"></div>
      </div>
    </div>
  </div>

  <p class="loading-label">Cargando...</p>
</div>
